import React from 'react';
import { Box } from '@chakra-ui/react';
import TablaProgramas from './TablaProgramas';

const Programas: React.FC = () => {
  return (
    <Box px={{ base: 2, md: 4 }} pt={79} pb={4}>
      <TablaProgramas />
    </Box>
  );
};

export default Programas;
